import styled from 'styled-components';

import {
  mediaConfined,
  mediaSmallOrTiny,
  mediaWideNavless,
} from '@xing-com/layout-tokens';
import { SkeletonImage } from '@xing-com/skeleton';
import {
  spaceL,
  spaceXL,
  spaceXXL,
  xdlColorTextSecondaryOnDark,
  xdlColorTextSecondaryOnLight,
} from '@xing-com/tokens';

const HeaderImageSkeleton = styled(SkeletonImage)`
  height: 220px;
  width: 100%;

  @media ${mediaConfined} {
    height: 398px;
  }

  @media ${mediaWideNavless} {
    height: 508px;
  }
`;

const HeaderImageContainer = styled.figure`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: ${spaceL} 0 ${spaceXXL};

  img {
    width: 100%;
    max-height: 100%;
  }

  @media ${mediaSmallOrTiny} {
    margin: 0 -${spaceL} ${spaceXL};
  }
`;

const HeaderImageCaption = styled.figcaption<{ $isDarkMode: boolean }>`
  color: ${({ $isDarkMode }) =>
    $isDarkMode ? xdlColorTextSecondaryOnDark : xdlColorTextSecondaryOnLight};
  margin-top: ${spaceL};
`;

export const Styled = {
  HeaderImageSkeleton,
  HeaderImageContainer,
  HeaderImageCaption,
};
